import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const PeriodControls = ({ 
  game, 
  syncing, 
  periodStartTimes,
  onPeriodStartTimesChange,
  onSetPeriod 
}) => {
  const periods = [
    { id: 'pregame', label: 'PRE-GAME', hasStartTime: false },
    { id: '1st_half', label: '1ST HALF', hasStartTime: true },
    { id: 'halftime', label: 'HALF TIME', hasStartTime: false },
    { id: '2nd_half', label: '2ND HALF', hasStartTime: true },
    { id: '1st_et', label: '1ST ET', hasStartTime: true },
    { id: 'halftime_et', label: 'HT (ET)', hasStartTime: false },
    { id: '2nd_et', label: '2ND ET', hasStartTime: true },
    { id: 'fulltime', label: 'FULL TIME', hasStartTime: false }
  ];

  return (
    <div className="space-y-4">
      <Card className="bg-[#1E293B] border-slate-700">
        <CardHeader className="pb-2">
          <CardTitle className="text-white font-body text-sm">Current Period</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-heading text-white text-center">
            {(game.period || 'pregame').replace('_', ' ').toUpperCase()}
          </p>
        </CardContent>
      </Card>

      <Card className="bg-[#1E293B] border-slate-700">
        <CardHeader className="pb-2">
          <CardTitle className="text-white font-body text-sm">Auto-Start Times</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {periods.filter(p => p.hasStartTime).map((period) => (
              <div key={period.id} className="space-y-1">
                <Label className="text-slate-400 font-body text-xs">{period.label}</Label>
                <Input
                  type="text"
                  value={periodStartTimes[period.id] || ''}
                  onChange={(e) => onPeriodStartTimesChange(period.id, e.target.value)}
                  placeholder="MM:SS"
                  className="bg-[#0F172A] border-slate-600 text-white font-mono h-10"
                />
              </div>
            ))}
          </div>
          <p className="text-slate-500 text-xs font-body mt-2 text-center">
            Timer will auto-start at these times when switching periods
          </p>
        </CardContent>
      </Card>

      <Card className="bg-[#1E293B] border-slate-700">
        <CardHeader className="pb-2">
          <CardTitle className="text-white font-body text-sm">Set Period</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-2">
            {periods.map((period) => (
              <Button
                key={period.id}
                data-testid={`period-${period.id}`}
                onClick={() => onSetPeriod(period.id)}
                disabled={syncing}
                className={`h-12 font-body touch-target ${
                  game.period === period.id 
                    ? 'bg-[#2A4A5C] text-white' 
                    : 'bg-slate-700 hover:bg-slate-600 text-slate-300'
                }`}
              >
                {period.label}
              </Button>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PeriodControls;
